import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaqItem } from '../item/faq-item';

interface FaqListProps {
    limit?: number;
    itemsKey?: string;
}

export const FaqList: React.FC<FaqListProps> = ({ limit, itemsKey = 'pages.faq.items' }) => {
    const { t } = useTranslation();
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const handleToggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    interface FaqItemProps {
        id: string;
        question: string;
        answer: string;
        imageUrl?: string;
    }

    const faqData: FaqItemProps[] = Object.values(t(itemsKey, { returnObjects: true }));

    const faqItems = limit ? faqData.slice(0, limit) : faqData;

    useEffect(() => {
        const hash = window.location.hash.replace('#', '');
        if (hash) {
            const index = faqData.findIndex((item) => item.id === hash);
            if (index !== -1) {
                setOpenIndex(index);
                document.getElementById(hash)?.scrollIntoView();
            }
        }
    }, [itemsKey]);

    return (
        <div className="flex flex-col gap-[1.2rem]">
            {faqItems.map((item, index) => (
                <FaqItem
                    key={item.id}
                    id={item.id}
                    question={item.question}
                    answer={item.answer}
                    imageUrl={item.imageUrl}
                    isOpen={openIndex === index}
                    onClick={() => {
                        handleToggle(index);
                        window.history.pushState({}, '', `#${item.id}`);
                    }}
                />
            ))}
        </div>
    );
};
